// 产品资料库
const Index = () => import('@/views/productdatabase/Index')
const Picture = () => import('@/views/productdatabase/components/PicturePreview')

export default [
  {
    path: '/productdatabase',
    component: Index,
    name: 'database',
    meta: {
      title: '产品资料库',
      keepAlive: true
    }
  },
  {
    path: '/productdatabase/picture',
    component: Picture,
    name: 'picture',
    meta: {
      title: '产品资料库'
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/productDatabase.js